export const buildActiveSharesArr = (buyQueues, currentPriceArr) => {
  const result = [];

  for (const investShortName in buyQueues) {
    for (const buyTx of buyQueues[investShortName]) {
      const qty = parseFloat(buyTx.remainingQty || 0);
      if (qty <= 0) continue; // Skip fully sold lots
          const initialPrice = parseFloat(buyTx.transactionRef.unitPrice || 0);
          const investShortName = buyTx.transactionRef.investShortName;
          let currentPrice = 0;
          const currentPriceObj = currentPriceArr.find(elem => elem.investShortName === investShortName);
          if (currentPriceObj){
              currentPrice = +currentPriceObj.currentPrice;
          }
          const totalInitialPrice = qty * initialPrice;
          const totalCurrentPrice = qty * currentPrice;
          const unrealizedGain = totalCurrentPrice - totalInitialPrice;
          result.push({
            investShortName,
            quantity: qty,
            initialPrice: initialPrice.toFixed(2),
            totalInitialPrice: totalInitialPrice.toFixed(2),
            currentPrice: currentPrice.toFixed(2),
            totalCurrentPrice: totalCurrentPrice.toFixed(2),
            totalGainLoss: unrealizedGain,
            transactionDate: buyTx.transactionRef.transactionDate,
            transNbr: buyTx.transactionRef.transNbr
          });
        }
  }

  return result;
};

export default buildActiveSharesArr;

